<div class="container-sidebar-competencies">
  <app-state [state]="state">
    <ng-container *ngIf="!state.loading && !state.error;">
      <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.SKILL_RATING) && isManagingSingleUser">
        <div class="p-bottom-15 text-right">
          <a [routerLink]="'/profile/' + userIds[0]">Add or update ratings</a>
        </div>
      </ng-container>

      <ng-container *ngIf="data.master.length > 0; else templateNoData;">
        <div class="data-list">
          <ng-container *ngFor="let competency of data.display; i as index;">
            <app-competency-display [competency]="competency" [competencyRating]="competency.competencyRating" [competencyRatingConfiguration]="competencyRatingConfiguration"></app-competency-display>
          </ng-container>
        </div>

        <app-pagination-new-component [arrayData]="data.filtered" [arrayDisplay]="data.display" #pagination></app-pagination-new-component>
      </ng-container>

      <ng-template #templateNoData>
        <app-empty-state [height]="'200px'" [imageSrc]="'assets/img/empty-state/empty-state-competencies.svg'" [message]="'No ' + (globals.getTerminology(eTerminologyEntity.COMPETENCY_PLURAL) | lowercase)"></app-empty-state>
      </ng-template>
    </ng-container>
  </app-state>
</div>